import { InspectionDetailsSchema as ClaimsInspectionDetailsSchema, PublicationTargetsSchema, } from '@eigtech/claims-v2-types';
import { SoftDateSchema } from '@eigtech/function-utils';
import { JobAppointmentIdSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
export const InspectorRoleSchema = z.enum(['fieldAdjuster', 'inspectionTechnician']);
export const InspectorRole = InspectorRoleSchema.enum;
export const InspectionStatusSchema = z.enum([
    'canceled',
    'completed',
    'readyForReview',
    'requested',
    'scheduled',
    'started',
]);
export const InspectionStatusEnum = InspectionStatusSchema.enum;
const BaseInspectionSchema = z.object({
    entityId: InspectionEntityCornSchema,
    inspectionId: InspectionCornSchema,
    publicationTargets: PublicationTargetsSchema.array().optional(),
    scheduledDate: z.iso.datetime(),
    status: InspectionStatusSchema,
});
const InspectionDetailsSchema = z.object({
    canceledBy: z.string(),
    claimsInspectionId: ClaimsInspectionDetailsSchema.shape.inspectionId,
    coverageConcerns: z.string(),
    description: z.string(),
    dateCanceled: SoftDateSchema,
    dateDeleted: SoftDateSchema,
    dateEnded: SoftDateSchema,
    dateReviewed: SoftDateSchema,
    dateStarted: z.iso.datetime(),
    deletedBy: z.string(),
    durationSeconds: z.number(),
    inspectorRole: InspectorRoleSchema,
    investigative: z.string(),
    labels: z.array(z.string()).default([]),
    lossCause: z.string(),
    markedAsCanceled: z.boolean(),
    notes: z.string(),
    origin: z.string(),
    endedBy: z.string(),
    requestedBy: z.string(),
    restorationAppointmentId: JobAppointmentIdSchema,
    reviewedBy: z.string(),
    riskOverview: z.string(),
    scheduledBy: z.string(),
    startedBy: z.string(),
    confirmed: z.boolean(),
    confirmedBy: z.string(),
    confirmedOn: z.string(),
});
export const InspectionSchema = BaseInspectionSchema.extend(InspectionDetailsSchema.partial().shape);
